import { array, number, object, string } from "yup"
import { currentStockPercentageField } from "./distribution-center.model"
import { ID2 } from "./yup.common"
export default object({
  id: ID2("Sellable Item"),
  name: string().required().label("Name"),
  codename: string().min(3).required().label("Codename"),
  photos: array().min(1, "Please upload atleast 1 Additional Photos"),
  itemGroups: array(),
  shortDescription: string()
    .min(3)
    .max(75)
    .label("Short Description")
    .required("Please give a short description about this item!"),
  longDescription: string().label("Long Description"),
  sellableVarieties: array().of(
    object({
      id: ID2("Sellable Item Crop"),
      name: string(),
      gradeId: ID2("Variety Grade").required("Please enter a valid grade!"),
      uomCount: number().positive().label("UOM Count"),
      uomTypeId: ID2("UOM Type").required(
        "Please enter uom type for the crop!"
      ),
      skuCount: number(),
      skuTypeId: ID2("Sku Type").required(
        "Please enter sku type for sellable crop"
      ),
      varietyId: ID2("Crop"),
    })
  ),
  transportationType: string().length(2),
  currentStockPercentage: currentStockPercentageField,
})
